import React from 'react';

type Props = {
  integrationName: string;
};

const OrderHelp = ({ integrationName }: Props) => {
  if (integrationName === 'Uber Eats') {
    return (
      <>
        <span>Order issues:</span> call Uber Eats at (833) 275-3287
      </>
    );
  }
  if (integrationName === 'Grubhub') {
    return (
      <>
        <span>Order issues:</span> call Grubhub at (877) 585-7878
      </>
    );
  }
  return (
    <>
      <span>Order issues:</span> call DoorDash at (855) 222-8111
    </>
  );
};

export default OrderHelp;
